// extracted by mini-css-extract-plugin
export default {"root":"Search_root__b8CF2","input":"Search_input__fU9bH","icon":"Search_icon__Chrt6","clearIcon":"Search_clearIcon__sZaPX"};